import { trainingApiClient } from "../../../../../http-common";

export const getDeptDropdown = async () => {
  return await trainingApiClient.get(`/masters/department/dropdown`);
};
export const getFrequencyTypeDropdown = async () => {
  return await trainingApiClient.get(`/masters/frequencyType/dropdown`);
};

export const getFrequencyUnitDropdown = async () => {
  return await trainingApiClient.get(`/masters/frequencyUnit/dropdown`);
};
export const getPostAssessmentDropdown = async () => {
  return await trainingApiClient.get(`/masters/assessmentType/postAssessmentDropdown`);
};

export const getPreAssessmentDropdown = async () => {
  return await trainingApiClient.get(`/masters/assessmentType/preAssessmentDropdown`);
};
export const getRiskLevelDropdown = async () => {
  return await trainingApiClient.get(`/masters/riskLevel/dropdown`);
};
export const getTrainingTypeDropdown = async () => {
  return await trainingApiClient.get(`/masters/trainingType/dropdown`);
};
// export const saveTrainingMaster = async (obj) => {
//   return await trainingApiClient.post(`/masters/training/save`, obj);
// };
// export const saveTrainingMaster = async (obj) => {
//   return await trainingApiClient.post(`/masters/training/save`, obj, {
//     headers: {
//       "Content-Type": "multipart/form-data",
//     },
//   });
// };

export const saveTrainingMaster = async (finalData) => {
  const payload = new FormData();

  //  @RequestPart("trainingData")
  payload.append(
    "trainingData",
    new Blob([JSON.stringify(finalData?.data)], {
      type: "application/json",
    }),
  );

  //  @RequestPart("videos")
  finalData.videoFiles?.forEach((file) => {
    payload.append("videos", file);
  });

  //  @RequestPart("documents")
  finalData.documentFiles?.forEach((file) => {
    payload.append("documents", file);
  });

  return trainingApiClient.post(`/masters/training/save`, payload);
};

// export const updateTrainingMaster = async (obj) => {
//   return await trainingApiClient.post(`/masters/training/update`, obj);
// };
export const updateTrainingMaster = async (finalData) => {
  const payload = new FormData();

  // @RequestPart("trainingData")
  payload.append(
    "trainingData",
    new Blob([JSON.stringify(finalData.data)], {
      type: "application/json",
    }),
  );

  // @RequestPart("videos")
  finalData.videoFiles?.forEach((file) => {
    payload.append("videos", file);
  });

  // @RequestPart("documents")
  finalData.documentFiles?.forEach((file) => {
    payload.append("documents", file);
  });
  return await trainingApiClient.post(`/masters/training/update`, payload);
};

export const getAllTrainingMasterList = async (obj) => {
  return await trainingApiClient.post(`/masters/training/getTrainingList`, obj);
};
export const getAllTrainingName = async (searchString) => {
  return await trainingApiClient.get(`/masters/training/getTrainingAutoComplete`, {
    params: {
      searchString,
    },
  });
};
export const getAssessmentQuestionsList = async (trainingId, assessmentId) => {
  return await trainingApiClient.get(`/masters/assessment/getAssessmentQuestion`, {
    params: {
      trainingId,
      assessmentId,
    },
  });
};
export const getTrainingMasterInfo = async (id) => {
  return await trainingApiClient.get(`/masters/training/getTrainingFindById`, {
    params: {
      id,
    },
  });
};
export const getRoleDropdown = async () => {
  return await trainingApiClient.get(`/masters/training/getRoleDropdown`);
};

export const getUnitDropdown = async () => {
  return await trainingApiClient.get(`/masters/unit/unitDropDown`);
};